var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, reaction } from "mobx";
import { SmartAuthProvider, SmartAuthType } from "../Logic/SmartAuthManager";
import { NamedRoutes } from "./NamedRoutes";
import { routeEquals } from "./RoutingUIManager";
import { effectiveQueryParams } from "./queryParams";
import { Persistence } from "../Infra/Persistence";
import { isErr } from "healthex-common/result";
export class SmartEHRLaunchUIManager {
    constructor(authManager, routingUIManager, provisioningService, smartAuthManager) {
        this.authManager = authManager;
        this.routingUIManager = routingUIManager;
        this.provisioningService = provisioningService;
        this.smartAuthManager = smartAuthManager;
        this.unloading = false;
        reaction(() => routingUIManager.currentRoute, async () => {
            var _a, _b, _c, _d;
            if (((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) === NamedRoutes.SMART_LAUNCH.routeName) {
                await this.handleSmartLaunch(false);
            }
            else if (((_b = this.routingUIManager.currentRoute) === null || _b === void 0 ? void 0 : _b.routeName) === NamedRoutes.SMART_LAUNCH_PROVIDER.routeName) {
                await this.handleSmartLaunch(true);
            }
            else if (((_c = this.routingUIManager.currentRoute) === null || _c === void 0 ? void 0 : _c.routeName) === NamedRoutes.SMART_CALLBACK.routeName) {
                await this.handleSmartCallback();
            }
            else if (((_d = this.routingUIManager.currentRoute) === null || _d === void 0 ? void 0 : _d.routeName) === NamedRoutes.SMART_FULL_LAUNCH.routeName) {
                await this.handleFullLaunch();
            }
        }, {
            fireImmediately: true,
            equals: routeEquals,
        });
    }
    static isEmbedded() {
        const smartAuthData = new Persistence().getSmartAuthData();
        if (smartAuthData && smartAuthData.provider === SmartAuthProvider.EPIC) {
            return smartAuthData.isEHRLaunch;
        }
        return false;
    }
    async handleSmartLaunch(isProvider) {
        var _a;
        const data = effectiveQueryParams();
        const vanitySubdomain = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.vanitySubdomain;
        const launch = data.get("launch");
        if (!launch) {
            void this.smartAuthManager.onSmartAuthError("Missing launch parameter");
            return;
        }
        if (!vanitySubdomain) {
            void this.smartAuthManager.onSmartAuthError("Missing organization name");
            return;
        }
        const orgProfiles = await this.provisioningService.getOrganizationPublicProfileByVanitySubdomain(vanitySubdomain);
        if (!orgProfiles.length) {
            void this.smartAuthManager.onSmartAuthError("Unknown organization");
            return;
        }
        try {
            const url = await this.smartAuthManager.startSmartAuth(SmartAuthProvider.EPIC, isProvider ? SmartAuthType.PROVIDER_AUTH : SmartAuthType.PATIENT_AUTH, this.getRedirectUri(), orgProfiles[0].id, launch);
            window.location.href = url;
            this.unloading = true;
        }
        catch (e) {
            void this.smartAuthManager.onSmartAuthError("Failed to initialize healthcare portal session");
            throw e;
        }
    }
    async handleSmartCallback() {
        var _a;
        const data = effectiveQueryParams();
        const error = (_a = data.get("error_description")) !== null && _a !== void 0 ? _a : data.get("error");
        const code = data.get("code");
        const state = data.get("state");
        if (error) {
            void this.smartAuthManager.onSmartAuthError(error);
        }
        else if (code) {
            void this.smartAuthManager.onSmartAuthComplete(code, state !== null && state !== void 0 ? state : "", this.getRedirectUri());
            window.history.replaceState(null, "", window.location.href.replace(window.location.search, ""));
        }
        else {
            void this.smartAuthManager.onSmartAuthError("Failed to retrieve code parameter");
        }
    }
    async handleFullLaunch() {
        var _a, _b;
        const shortLivedToken = (_b = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.shortLivedToken) !== null && _b !== void 0 ? _b : "";
        const result = await this.authManager.authenticateByShortLivedToken(shortLivedToken);
        if (isErr(result)) {
            console.warn(`Error: ${JSON.stringify(result)}`);
        }
        this.routingUIManager.redirectTo(NamedRoutes.INDEX);
    }
    getRedirectUri() {
        return `${window.location.origin}/#/smart-callback`;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], SmartEHRLaunchUIManager.prototype, "unloading", void 0);
